var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3334 6.66675H13.3334V26.6667H33.3334V6.66675ZM31.6667 18.3334H25V25.0001H21.6667V18.3334H15V15.0001H21.6667V8.33341H25V15.0001H31.6667V18.3334Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 36.6666H30V33.3333H6.66671V9.99992H3.33337V33.3333C3.33337 35.1666 4.83337 36.6666 6.66671 36.6666ZM13.3334 29.9999H33.3334C35.1667 29.9999 36.6667 28.4999 36.6667 26.6666V6.66659C36.6667 4.83325 35.1667 3.33325 33.3334 3.33325H13.3334C11.5 3.33325 10 4.83325 10 6.66659V26.6666C10 28.4999 11.5 29.9999 13.3334 29.9999ZM13.3334 6.66659H33.3334V26.6666H13.3334V6.66659ZM25 8.33325H21.6667V14.9999H15V18.3333H21.6667V24.9999H25V18.3333H31.6667V14.9999H25V8.33325Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.3334,
    y1: 6.66675,
    x2: 36.1965,
    y2: 22.5439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3.33337,
    y1: 3.33325,
    x2: 41.4385,
    y2: 29.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToPhotos);
export default __webpack_public_path__ + "static/media/add_to_photos.781de26da00573a64f7a7d2c71eee97b.svg";
export { ForwardRef as ReactComponent };